<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .add-email {
    width: 100%;
    height: utils.in_rem(34px);
    animation: shimmer 1.5s infinite linear;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    border-radius: 8px;
  }

  .body {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
</style>

<script>
  let cls = "";
  export { cls as class };
  export let count = 1;
</script>

<div class="body {cls}">
  {#each Array(count) as _}
    <div class="add-email"></div>
  {/each}
</div>
